<template>
  <component v-bind="$attrs" :is="is" v-if="!!is">
    <slot />
  </component>
  <button
    type="button"
    class="menu-item"
    role="menuitem"
    v-bind="$attrs"
  >
    <slot />
  </button>
</template>

<script lang="ts" setup>
import type { FunctionalComponent } from 'vue';

interface Props {
  is?: FunctionalComponent;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.menu-item {
  @apply text-menu text-left;
  @apply py-2.5 px-14;
  @apply whitespace-nowrap;

  &:hover {
    @apply bg-red-120 text-white;
  }
}
</style>
